window.customElements.define("ua-breadcrumbs", class UABreadcrumbs extends HTMLElement {
  constructor() {
    super();

    this.localStorageKey = 'ua-breadcrumbs';

    window.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('a[href*="/products/"]').forEach((item) => {
        item.addEventListener('click', () => {
          localStorage.removeItem(this.localStorageKey);
        });
      });
    });
  }
});